import { RULE_FORM } from '../../types';

export const EMPTY_RULE: RULE_FORM = {
  description: '',
  expression: '',
  service: null,
};
